import React from "react";

import clsx from "clsx";

import { usePrettyLogEventPage } from "@components/v2/analytics";
import { IconButton } from "@shared/buttons";

import { useAnnotationParam } from "./hooks/use-annotation-param";

interface AnnotationsFlyoutButtonProps {
  dateRange: { startDate: string; endDate: string };
  disabled?: boolean;
  buttonText?: string;
  buttonClass?: string;
}

export const AnnotationsFlyoutButton = ({
  dateRange,
  disabled = false,
  buttonText = "NOTES",
  buttonClass,
}: AnnotationsFlyoutButtonProps) => {
  const { listDateRangeAnnotations } = useAnnotationParam();
  const prettyLogEventPage = usePrettyLogEventPage();
  const openAnnotationsFlyout = () => {
    listDateRangeAnnotations(dateRange);
    prettyLogEventPage({
      domain: "Annotations",
      action: "onClick",
      additionalActionInfo: "Notes button on graph",
      data: { dateRange },
    });
  };

  return (
    <IconButton
      className={clsx(
        "font-bold bg-v2-primary text-v2-primary border-v2-secondary",
        buttonClass,
      )}
      onClick={openAnnotationsFlyout}
      variant="secondary"
      leftIcon={<i className="fa-regular fa-sharp fa-message mr-1" />}
      disabled={disabled}
    >
      {buttonText}
    </IconButton>
  );
};
